import styles from './RightColumnWrapperVersionTwo.css'

class RightColumnWrapperVersionTwo extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      openRightColumn: props.openRightColumn
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.state.openRightColumn !== nextProps.openRightColumn) {
      if (nextProps.openRightColumn) {
        setTimeout(() => {
          this.setState({openRightColumn: nextProps.openRightColumn})
        }, 600)
      } else {
        this.setState({openRightColumn: nextProps.openRightColumn})
      }
    }
  }

  render () {
    const {openRightColumn} = this.state
    const {menuName} = this.props
    let classSlider = openRightColumn ? 'col-md-7 col-lg-7 visible-md visible-lg visible-sm' : `col-md-12 col-lg-12`

    // This is for handling redux-form issue
    // https://github.com/erikras/redux-form/issues/2971
    // when we reset redux form component, it will not running validation
    // because we have bug in redux form validation library
    // so we destroy the component when this part got hide
    // and we re-mount the component when it showed
    return (<div id='mk-col-right' className={`${styles.wrapper} ${classSlider} ${menuName}`}>
      {openRightColumn && this.props.children}
    </div>)
  }
}

export default RightColumnWrapperVersionTwo



// WEBPACK FOOTER //
// ./app/components/wrappers/pages/RightColumnWrapperVersionTwo/RightColumnWrapperVersionTwo.js